import '../../styles/DashboardComponents.css';

// Arrondi à la dizaine
const roundToTens = (value) => Math.round(value / 10) * 10;

const SavingsPerMeasure = ({ data }) => {
  if (!data) return null;

  // Transformer l'objet en tableau pour le trier éventuellement
  const sortedData = Object.entries(data)
    .map(([measure, values]) => ({
      measure,
      waterSavings: values.water_savings,
      costSavings: roundToTens(values.cost_savings), // arrondi à la dizaine
    }))
    // Trier par économie d'eau décroissante
    .sort((a, b) => b.waterSavings - a.waterSavings);

  return (
    <table className="equipment-table">
      <thead>
        <tr>
          <th>Mesure</th>
          <th>Économie d'eau (m3/an)</th>
          <th>Économie coût (€)</th>
        </tr>
      </thead>
      <tbody>
        {sortedData.map((item, index) => (
          <tr key={index}>
            <td>{item.measure}</td>
            <td>{Math.round(item.waterSavings)}</td>
            <td>{item.costSavings}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default SavingsPerMeasure;
